export default "__VITE_ASSET__DfSM_RpP__"